<template>
  <v-dialog
    ref="updateFileDialog"
    v-model="localdialog"
    max-width="600px"
    persistent
    transition="dialog-bottom-transition"
    class="dialog-zindex"
  >
    <template #activator="{ on }">
      <CotizadorBtn
        v-if="!withoutActivator"
        dark
        :on="on"
        :disabled="disabled"
        content-class="w-100"
      >
        <img
          class="ma-2 btn-icon-presupuesto"
          src="@/assets/cart.svg"
          alt="cart"
        />
        <span>{{ $t("presupuesto.fichaReprocesos.titulop1") }}</span>
      </CotizadorBtn>
    </template>
    <v-card>
      <v-card-text>
        <v-col class="disenoBody">
          <!-- Añadir diseño -->
          <v-row class="mt-1">
            <v-col>
              <div class="subtitle">
                {{ $t("presupuesto.diseñoSubtitle") }}
              </div>
              <div class="infoDesign mt-2">
                {{ $t("presupuesto.diseñoHelper") }}
              </div>
              <div>
                <v-btn
                  :loading="isSelecting || loadingCarrito || loading"
                  class="mt-3 fileBtn"
                  large
                  @click="handleFileImport"
                >
                  <v-icon color="primary" class="mr-3">mdi-plus-circle</v-icon>
                  {{ $t("presupuesto.diseñoUpload") }}
                </v-btn>
                <input
                  ref="uploader"
                  class="d-none"
                  type="file"
                  accept=".svg,application/pdf,.ai,.eps"
                  @change="selectFile"
                />
              </div>
            </v-col>
            <v-col v-if="actualDesign || isProcessing" class="imgContainer">
              <template v-if="actualDesign">
                <v-img
                  :key="idImg"
                  class="centerImg"
                  :src="actualDesign"
                  width="100%"
                  contain
                ></v-img>
                <div class="centerContainer">
                  <v-btn @click="deleteImg">
                    {{ $t("configuration.ReprocesosGenerales.Eliminar") }}
                    <v-icon>$fi-trash-2</v-icon>
                  </v-btn>
                </div>
              </template>
              <template v-else-if="isProcessing">
                <v-expand-transition>
                <v-card
                  flat
                  outlined
                  color="grey lighten-5"
                  class="mt-4 mb-2 pa-2"
                >
                  <div class="caption font-weight-bold mb-2 primary--text d-flex align-center">
                    <v-progress-circular
                       indeterminate
                       color="primary"
                       size="16"
                       width="2"
                       class="mr-2"
                    ></v-progress-circular>
                    {{ $t("general.fileUpdate.Title") }}
                  </div>

                  <!-- 1. Conexión -->
                  <div class="d-flex align-center mb-1 caption" :class="connectionId ? 'primary--text' : 'grey--text'">
                    <v-icon small :color="connectionId ? 'primary' : 'grey lighten-1'" class="mr-2">
                      {{ connectionId ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                    </v-icon>
                    {{ $t("general.fileUpdate.ConectApi") }}
                  </div>

                  <!-- 2. Validar -->
                  <div class="d-flex align-center mb-1 caption" :class="steps.validating ? 'primary--text' : 'grey--text'">
                    <v-icon small :color="steps.validating ? 'primary' : 'grey lighten-1'" class="mr-2">
                      {{ steps.validating ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                    </v-icon>
                    {{ $t("general.fileUpdate.Validating") }}
                  </div>

                  <!-- 3. Analizar Dimensiones -->
                  <div class="d-flex align-center mb-1 caption" :class="steps.analyzing ? 'primary--text' : 'grey--text'">
                    <v-icon small :color="steps.analyzing ? 'primary' : 'grey lighten-1'" class="mr-2">
                      {{ steps.analyzing ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                    </v-icon>
                    {{ $t("general.fileUpdate.AnalyzingDimensions") }}
                  </div>
                  
                  <!-- Info Extra: Dimensiones detectadas -->
                  <v-alert
                    v-if="detectedDimensions"
                    dense
                    text
                    type="info"
                    class="my-1 py-1 caption"
                    icon="mdi-ruler-square"
                  >
                    {{ $t("general.fileUpdate.DetectedDimensions") }}: <strong>{{ detectedDimensions.width }}x{{ detectedDimensions.height }}px</strong>
                  </v-alert>

                  <!-- 4. Renderizado -->
                  <div class="d-flex align-center mb-1 caption" :class="steps.rendering ? 'primary--text' : 'grey--text'">
                    <v-icon small :color="steps.rendering ? 'primary' : 'grey lighten-1'" class="mr-2">
                      {{ steps.rendering ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                    </v-icon>
                    {{ $t("general.fileUpdate.RenderingImage") }}
                  </div>

                  <!-- 5. Colores -->
                  <div 
                    class="d-flex align-center mb-1 caption" 
                    :class="steps.colorsAnalyzed ? 'primary--text' : 'grey--text'"
                  >
                    <v-icon small :color="steps.colorsAnalyzed ? 'primary' : 'grey lighten-1'" class="mr-2">
                      {{ steps.colorsAnalyzed ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                    </v-icon>
                    {{ $t("general.fileUpdate.AnalyzingColors") }}
                    <strong v-if="colorCount !== null" class="ml-1">({{ colorCount }} {{ $t("general.Colores") }})</strong>
                  </div>

                  <!-- 6. Finalizar -->
                  <div class="d-flex align-center caption" :class="steps.finished ? 'primary--text' : 'grey--text'">
                    <v-icon small :color="steps.finished ? 'primary' : 'grey lighten-1'" class="mr-2">
                      {{ steps.finished ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                    </v-icon>
                    {{ $t("general.fileUpdate.FinishingUp") }}
                  </div>
                </v-card>
              </v-expand-transition>
              </template>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col>
              <h4>
                {{ $t("presupuesto.diseñoAlternative") }}
              </h4>
            </v-col>
          </v-row>
          <v-row v-if="visualColors?.length" class="mt-3">
            <v-col cols="12">
              <h4 class="mb-3 text-uppercase text-subtitle-2 font-weight-bold text-grey-darken-1">
                {{ $t("general.fileUpdate.diseñoDetectedColors") }}
                <span class="text-caption ml-2">({{ visualColors.length }})</span>
              </h4>

              <div class="pantone-grid">
                <div
                  v-for="(color, index) in filteredVisualColors"
                  :key="index"
                  class="pantone-card"
                >
                  <!-- Izquierda: Swatch de Color (24x24) -->
                  <div class="swatch-wrapper">
                    <div 
                      class="color-swatch" 
                      :style="{ backgroundColor: color.hex }"
                      :title="`Hex: ${color.hex}`"
                    ></div>
                  </div>

                  <!-- Derecha: Información Compacta -->
                  <div class="info-wrapper">
                    <!-- Línea 1: Código Pantone -->
                    <div class="pantone-code" :title="color.name">
                      {{ color.code }}
                    </div>
                    
                    <!-- Línea 2: Solo se muestra si el detectado es diferente al Pantone (Aproximación) -->
                    <div 
                      v-if="color.detectedHex && color.detectedHex !== color.hex" 
                      class="hex-code"
                    >
                      {{ color.hex }}
                    </div>
                  </div>
                </div>

                <div v-if="visualColors?.length > filteredVisualColors.length" class="caption grey--text">
                  {{ $t("general.fileUpdate.diseñoMoreColorsHidden", { count: visualColors.length - filteredVisualColors.length }) }}
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row class="mt-6">
            <v-col>
              <h3>{{ $t("presupuesto.Observaciones") }}</h3>
              <v-textarea v-model="observaciones" class="mt-3" filled dense />
            </v-col>
          </v-row>
        </v-col>
         <v-alert
          v-if="showColorValidationWarning"
          dense
          text
          type="warning"
          class="mx-4 mb-3"
        >
          {{ $t("general.fileUpdate.colorWarning") }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="closeDialog">
          {{ $t("general.Cancelar") }}
        </v-btn>
        <v-btn color="primary" :disabled="!canSave" text @click="saveFileAndCloseDialog">
          {{ $t("general.Guardar") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CotizadorBtn from "@/components/basic/CotizadorBtn.vue";
import { TurnPostscriptToPng, SignalRConection, FetchNumColor } from "@/api/reprocesos";

export default {
  components: {
    CotizadorBtn
  },
  props: {
    // Mostramos el botón por defecto
    withoutActivator: {
      type: Boolean,
      default: false
    },
    // Prop para controlar el dialog
    dialog: {
      type: Boolean,
      default: false
    },
    // Prop para controlar si esta activo o no
    disabled: {
      type: Boolean,
      default: false
    },
    zona: {
      type: Object,
      required: true
    },
    isActive3D: {
      type: [String, Boolean],
      required: true
    }
  },
  data() {
    return {
      localdialog: false,
      isSelecting: false,
      actualDesign: null,
      originalFile: null,
      plainFile: null,
      idImg: 0,
      observaciones: "",
      loading: false,
      eliminando: false,
      numImgSaved: 0,

      debounceInitizalizeFromDesign: null,

      // Funcionamiento para el websocket
      isProcessing: false,
      connection: null,
      connectionId: "",
      signalRState: {
        status: "idle",
        attemptCount: 0,
        lastError: null
      },
      steps: {
        validating: false,
        analyzing: false,
        rendering: false,
        analyzingColors: false, // Nuevo paso
        colorsAnalyzed: false,  // Nuevo paso
        finished: false
      },
      detectedDimensions: null,
      colorCount: null,
      colorRequired: false,
      colorConfirmed: false,
      metadataColors: [], 
      visualColors: []
    };
  },
  computed: {
    ...mapGetters("carrito", ["loadingCarrito"]),
    ...mapGetters("modelo", ["modelCode"]),
    ...mapGetters("design", ["actualListDesign", "getDesignByIdAndZone"]),
    ...mapGetters('config', ['key']),
    canSave() {
      if (this.isProcessing) return false;
      if (!this.colorRequired) return true;

      return this.colorConfirmed && this.colorCount !== null;
    },
    showColorValidationWarning() {
      return this.colorRequired && !this.colorConfirmed && !this.isProcessing;
    },
    filteredVisualColors() {
      return this.visualColors
        .filter(c => c.coveragePercent > 1)
        .sort((a, b) => b.coveragePercent - a.coveragePercent);
    }
  },
  watch: {
    // Tratamiento para las modificaciones del dialogo
    dialog(newVal) {
      if (this.localdialog != newVal) {
        this.localdialog = newVal;
      }
    },
    localdialog(newVal, oldVal) {
      if (newVal == oldVal) return;

      if (newVal != this.dialog) {
        this.$emit("update:dialog", newVal);
      }

      if (!newVal) {
        this.$emit("close-dialog");
      }

      if (newVal && !oldVal) {
        this.resetImg();
        this.tryInitializeFromDesignList();
      }
    },
    actualListDesign: {
      handler(newVal) {
        if (!this.localdialog) return;
        if (newVal?.length || (newVal?.length == 0 && this.idImg > 0)) {
          // Intentamos recuperar la imagen para la zona
          this.tryInitializeFromDesignList();
  
          this.saveFileAndCloseDialog();
        }

      },
      deep: true
    },
    // Si se cambia de modelo, debemos resetear
    modelCode(newVal, oldVal) {
      if (newVal != oldVal) {
        this.localdialog = false;
        this.resetImg();
      }
    },
    zona(newVal, oldVal) {
      if (newVal != oldVal) {
        // Reiniciamos la imagen actual
        this.localdialog = false;
        this.resetImg();

        // Intentamos recuperar la imagen para la zona
        this.tryInitializeFromDesignList();
      }
    }
  },
  beforeDestroy() {
      this.stopSignalRConnection();
  },
  methods: {
    ...mapActions("design", ["deleteZoneCustomDesign"]),
    ...mapActions("modelo", ["addAlert"]),
    deleteImg() {
      this.eliminando = true;
      this.resetImg();
    },
    // Función para resetear el dialogo
    resetImg() {

      this.actualDesign = null;
      this.plainFile = null;
      this.idImg = 0;
      this.observaciones = "";
      this.originalFile = null;
      this.metadataColors = [];
      this.visualColors = [];
      this.colorCount = null;
      this.colorRequired = false;
      this.colorConfirmed = false;
      this.signalRState = {
        status: "idle",
        attemptCount: 0,
        lastError: null
      };
      Object.keys(this.steps).forEach(k => this.steps[k] = false);
    },

    // Función para cerrar el modal
    closeDialog() {
      this.localdialog = false;
    },
    saveFile() {
      const validImg = (this.actualDesign || this.plainFile) || this.observaciones;

      if (!validImg) {
        this.$emit("update-image", null);
        return;
      }

      this.$emit("update-image", {
        base64: this.actualDesign,
        plainFile: this.plainFile,
        originalFile: this.originalFile,
        id: this.idImg,
         observaciones: this.observaciones,
        index: this.numImgSaved,
         zona: this.zona,
         numColor: this.colorCount,
         metadataColors: this.metadataColors,
        visualColors: this.visualColors
      });
    },
    // Cerramos el modal y propagamos el resultado
    saveFileAndCloseDialog() {
      if (!this.canSave) {
        return;
      }

      this.closeDialog();
      this.saveFile();

      if (this.eliminando)
      {
        //Eliminamos la zona personalizada
        this.deleteZoneCustomDesign({
          id: this.zona?.id,
          posicion: this.zona.Posicion
        });

        this.eliminando = false;
      }
    },
    resetSignalRState() {
      this.signalRState.status = "idle";
      this.signalRState.attemptCount = 0;
      this.signalRState.lastError = null;
    },
    bindSignalRListeners() {
      if (!this.connection) return;

      this.connection.off("ProgressUpdate");
      this.connection.on("ProgressUpdate", msg => {
        const payload = msg.data && msg.data.additionalData ? msg.data.additionalData : {};

        switch(msg.step) {
          case "VALIDATING_FILE":
            this.steps.validating = true;
            break;
          case "EXTRACTING_METADATA":
            console.log("Extrayendo metadatos de pantones...");
            break;
          case "METADATA_FOUND":
            console.log("Metadatos encontrados:", payload);
            break;
          case "CALCULATING_DIMENSIONS":
            this.steps.analyzing = true;
            break;
          case "DIMENSIONS_FOUND":
            if (payload.width && payload.height) {
              this.detectedDimensions = payload;
            }
            break;
          case "RENDERING_IMAGE":
            this.steps.rendering = true;
            break;
          case "ANALYZING_COLORS":
            this.steps.analyzingColors = true;
            break;
          case "VECTOR_CHECK_WARNING":
            this.addAlert({ code: "alertInvalidFileTypeReprocesos" });
            this.steps.finished = true;
            break;
          case "COLORS_ANALYZED": {
            this.steps.colorsAnalyzed = true;
            const hasVisualCount = typeof payload.visualCount === "number";
            this.colorCount = hasVisualCount ? payload.visualCount : null;
            this.metadataColors = payload.metadataColors || [];
            this.visualColors = payload.visualColors || [];
            this.colorConfirmed = hasVisualCount;
            break;
          }
          case "FINISHED":
            this.steps.finished = true;
            break;
          default:
            console.log("SignalR Event:", msg.step);
        }
      });

      this.connection.onreconnecting(error => {
        this.signalRState.status = "connecting";
        this.signalRState.lastError = error?.message || "SignalR reconnecting";
      });

      this.connection.onreconnected(() => {
        this.signalRState.status = "connected";
        this.connectionId = this.connection?.connectionId || this.connectionId;
      });

      this.connection.onclose(error => {
        if (this.signalRState.status !== "closing") {
          this.signalRState.status = "failed";
          this.signalRState.lastError = error?.message || "SignalR closed";
        }
      });
    },
    // Método auxiliar para iniciar conexión bajo demanda con el websocket
    async startSignalRConnection() {
      if (!this.key) {
        this.signalRState.status = "failed";
        this.signalRState.lastError = "No hay clave de autorizacion disponible.";
        return false;
      }

      await this.stopSignalRConnection();
      this.resetSignalRState();

      const retryDelays = [0, 800, 1600];
      for (let i = 0; i < retryDelays.length; i++) {
        this.signalRState.attemptCount = i + 1;
        this.signalRState.status = "connecting";

        if (retryDelays[i] > 0) {
          await new Promise(resolve => setTimeout(resolve, retryDelays[i]));
        }

        try {
          this.connection = SignalRConection({ reprocesosKey: this.key });
          this.bindSignalRListeners();
          await this.connection.start();
          this.connectionId = this.connection.connectionId;
          this.signalRState.status = "connected";
          this.signalRState.lastError = null;
          console.log("SignalR conectado:", this.connectionId);
          return true;
        } catch (error) {
          this.signalRState.status = "failed";
          this.signalRState.lastError = error?.message || "Error de conexion";
          await this.stopSignalRConnection();
        }
      }

      return false;
    },
    // Método auxiliar para detener la conexión con el websocket
    async stopSignalRConnection() {
      if (!this.connection) {
        this.connectionId = "";
        return;
      }

      try {
        this.signalRState.status = "closing";
        this.connection.off("ProgressUpdate");
        await this.connection.stop();
      } catch (error) {
        console.error("Error cerrando SignalR:", error);
      } finally {
        this.connectionId = "";
        this.connection = null;
        if (this.signalRState.status === "closing") {
          this.signalRState.status = "idle";
        }
        console.log("SignalR desconectado");
      }
    },
    async ensureColorCountFromFallback(base64Image) {
      const file = this.base64ToFile(base64Image, "parser-preview.png", "image/png");
      const formData = new FormData();
      formData.append("file", file);

      const response = await FetchNumColor({
        reprocesosKey: this.key,
        fileInfo: formData
      });

      const colors = Array.isArray(response?.data) ? response.data : [];
      this.colorCount = colors.length;
      this.visualColors = colors;
      this.metadataColors = [];
      this.colorConfirmed = true;
      this.steps.analyzingColors = true;
      this.steps.colorsAnalyzed = true;
    },
    base64ToFile(base64Data, fileName, mimeType) {
      const base64Parts = base64Data.split(",");
      const content = base64Parts.length > 1 ? base64Parts[1] : base64Parts[0];
      const byteCharacters = atob(content);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.codePointAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
      }

      return new File(byteArrays, fileName, { type: mimeType });
    },

    // Función para manejar el input de archivos
    handleFileImport() {
      this.isSelecting = true;

      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.value = null;
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    // Función para seleccionar un archivo
    selectFile(event) {
    
      const file = event.target.files[0];

      if (file) {
          if (file.size > 15000000) {
              alert(this.$t("errores.alert.alertSizeBiggerThan15Mb"));
          } else {
            this.loading = true;
              const reader = new FileReader();

              reader.addEventListener(
                  "loadend",
                  async () => {
                      
                    try {
                        let base64 = null;
                      this.originalFile = reader.result;

                      // UNIFICACIÓN: Tratamos PDF, SVG y PostScript (EPS/AI) igual
                      // Enviándolos al backend para procesar y recortar
                      if (file.type == "application/pdf" || file.type == "application/postscript" || file.type == "image/svg+xml") {

                        this.detectedDimensions = null;
                        this.colorCount = null;
                        this.colorRequired = true;
                        this.colorConfirmed = false;
                        this.resetSignalRState();
                        Object.keys(this.steps).forEach(k => this.steps[k] = false);

                        const formData = new FormData();
                        formData.append("file", file);

                        try {
                          this.isProcessing = true;
                          const isSignalrConnected = await this.startSignalRConnection();
                          if (!isSignalrConnected) {
                            console.warn("SignalR no pudo conectarse tras 3 intentos.");
                          }
                          // Reusamos la misma función.
                          // El backend ya sabe distinguir por cabeceras si es PDF o PS.
                          const pngBase64 = await TurnPostscriptToPng({
                            reprocesosKey: this.key,
                            fileInfo: formData,
                            connectionId: this.connectionId
                          });

                          base64 = pngBase64;
                          if (!this.colorConfirmed) {
                            await this.ensureColorCountFromFallback(base64);
                          }
                          this.steps.finished = true;
                        } catch (error) {
                          console.error("Error procesando vector:", error);
                          this.actualDesign = null;
                          this.colorConfirmed = false;
                          return;
                        } finally {
                          await this.stopSignalRConnection();
                          event.target.value = null;
                          this.isProcessing = false;
                        }
                      }
                      else {
                         this.addAlert({
                          code: "alertInvalidFileTypeReprocesos",
                        });
                        this.originalFile = null;
                        return;
                      }
                     
                      // Imágenes normales (png, jpg) pasan directo con el reader.result original.

                      this.actualDesign = base64;
                      this.plainFile = file;
                    this.idImg = this.generateIdPersonalization();
                    }
                    finally {
                        this.loading = false
                      }
                  },
                  { once: true }
              );

              reader.readAsDataURL(file);
          }
        }

        
  },

    // Función para generar un id para la personalizacion
    generateIdPersonalization() {
      return Math.floor(Math.random() * 2147483647);
    },

    // Función para inicializar el diseño desde la lista de diseños
    tryInitializeFromDesignList() {
      if (this.disabled) return;
      this.loading = true;

      if(this.debounceInitizalizeFromDesign) {
        clearTimeout(this.debounceInitizalizeFromDesign);
      }

      this.debounceInitizalizeFromDesign = setTimeout(() => {
        if (this.actualListDesign && this.actualListDesign.length > 0) {


        let design = this.getDesignByIdAndZone({ id: this.zona?.id ?? -1, posicion: this.zona.Posicion });

        if (design && (this.idImg == 0 || this.idImg != design.idImg)) {
          // Cargamos la imagen design en actualDesign y aumentamos el indice
          this.actualDesign = design.design;
          this.originalFile = design.originalFile;
          this.plainFile = design.plainFile;
          this.idImg = design.idImg;
          this.observaciones = design.observaciones;
          this.textDesing = design.textDesign;
          this.colorCount = typeof design.numColor === "number" ? design.numColor : null;
          this.colorRequired = this.colorCount !== null;
          this.colorConfirmed = this.colorCount !== null;
          this.metadataColors = design.metadataColors;
          this.visualColors = design.visualColors;
          this.saveFile();
        }
        else if(!design) {
          this.$emit("update-image", null);
          console.error("EXCEPCION 1");
          this.resetImg();
        }
      }
      else {
        this.$emit("update-image", null);
          console.error("EXCEPCION 2", this.actualListDesign?.length ?? 0);
        this.resetImg();
        }
        this.loading = false;
      }, 700);
    }
  }
};
</script>

<style lang="scss">

.imgContainer .v-image {
  border-radius: 0.25rem;
  border: 1px solid var(--Color-Grey-500, #787878);
  padding: 5px;
}
.pantone-grid {
  display: grid;
     grid-template-columns: 1fr 1fr;
  gap: 8px;
  width: 100%;
}

.pantone-card {
  display: flex;
  align-items: center; /* Centrado vertical general */
  background-color: #ffffff;
  border: 0px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px; /* Padding reducido */
  transition: all 0.2s ease;
  height: 38px; /* Altura fija para consistencia (24px contenido + padding) */
  
  &:hover {
    border-color: #b0b0b0;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  }

  .swatch-wrapper {
    flex-shrink: 0;
    margin-right: 8px;
    height: 24px; /* Forzamos altura del contenedor */

    .color-swatch {
      width: 24px;
      height: 24px;
      box-shadow: inset 0 0 0 1px rgba(0,0,0,0.1); 
    }
  }

  .info-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center; /* Si solo hay 1 línea, la centra verticalmente */
    height: 24px; /* Misma altura que el cuadrado */
    overflow: hidden;

    .pantone-code {
      font-size: 10px;
      line-height: 11px; /* Ajustado para que quepan 2 líneas */
      font-weight: 700;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .hex-code {
      font-size: 10px;
      line-height: 11px;
      color: #777;
      font-family: 'Roboto Mono', monospace;
      margin-top: 1px; /* Pequeña separación */
    }
  }
}

</style>
